import React from 'react';

/**
 * Placeholder episode artwork (no photography provided — see readme.md).
 * Rotates 3 brand palettes by seed and sets the Vol number in display type.
 */
export function CoverTile({ vol, size = 56, seed, image, fallback, className = '', style }) {
  const raw = seed != null ? seed : vol;
  // String seeds (e.g. backend IDs like "9rfJdF1X") hash by char codes so palettes still rotate.
  const num =
    typeof raw === 'string' && Number.isNaN(Number(raw))
      ? Array.from(raw).reduce((acc, ch) => acc + ch.charCodeAt(0), 0)
      : Number(raw) || 0;
  const palette = Math.abs(num) % 3;
  const n = typeof size === 'number' ? size : null;
  return (
    <span
      className={`bjl-covertile bjl-covertile--${palette} ${className}`}
      style={{ width: size, height: size, padding: n != null ? Math.max(4, Math.round(n * 0.09)) : '8%', ...style }}
      aria-hidden="true"
    >
      {image ? (
        <img
          src={image}
          alt=""
          onError={(e) => {
            if (fallback && e.currentTarget.src !== fallback) {
              e.currentTarget.src = fallback;
            }
          }}
        />
      ) : (
        <>
          <span className="bjl-covertile__vol" style={n != null ? { fontSize: Math.round(n * 0.3) } : undefined}>
            {vol != null ? String(vol).padStart(2, '0') : '边角'}
          </span>
          {n == null || n >= 96 ? <span className="bjl-covertile__brand">边角聊 · LEFTOVER TALK</span> : null}
        </>
      )}
    </span>
  );
}
